var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dashboard',{key:_vm.goal_id,attrs:{"goal-id":_vm.goal_id}})}
var staticRenderFns = []

export { render, staticRenderFns }